import { ChevronDownIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { icon } from "@/constants";
import { useEffect, useState } from "react";
import { Input } from "@/components/Inputs";
import { LoadingSkeleton2, LoadingSkeleton3 } from "@/components/Skeletons";
import StatusLine from "@/components/StatusLine";
import useAuth from "@/hooks/useAuth";
import axios from "axios";

export default () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingDetails, setIsLoadingDetails] = useState(false);
    const [orders, setOrders] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [email, setEmail] = useState("");
    const { user } = useAuth();

    useEffect(() => {
        if (!orders || orders.length <= 0) {
            const fetchData = async () => {
                setIsLoading(true);
                try {
                    const response = await axios.get(
                        process.env.REACT_APP_API_URL +
                            "/OnlineOrdering/GetCustomerOrdersHistory?CustomerId=" +
                            user.data.userId
                    );
                    setOrders(response.data.data);
                } catch (error) {
                    console.error(error);
                } finally {
                    setIsLoading(false);
                }
            };
            fetchData();
        }
    }, []);

    useEffect(() => {
        if (orders && orders.length > 0) {
            onSelectOrder(orders[0]);
        }
    }, [orders]);

    const onSelectOrder = async (order) => {
        try {
            setIsLoadingDetails(true);
            const { data } = await axios.get(
                process.env.REACT_APP_API_URL +
                    "/OnlineOrdering/GetCustomerOrderItemsHistory?OrderNumber=" +
                    order.orderNumber
            );
            order["orderItems"] = data.data;
            setSelectedOrder(order);
        } catch (error) {
            setSelectedOrder(null);
            console.log(error);
        } finally {
            setIsLoadingDetails(false);
        }
    };

    return (
        <main className="relative w-full">
            <div className="pb-6 md:pb-12 flex flex-col md:flex-row justify-center items-start padding-x">
                <section className="sm:max-h-[90vh] flex flex-col justify-between bg-white p-2 rounded-lg relative md:sticky md:top-8 z-0 w-full md:w-1/3 md:mr-5 mb-6 md:mt-0">
                    <div className="flex justify-between items-center p-2">
                        <h2 className="text-lg">Order History</h2>
                        <MagnifyingGlassIcon className="cursor-pointer text-shade-dark w-5 h-5" />
                    </div>
                    {orders.length > 0 ? (
                        <>
                            <div className="border-y overflow-y-scroll w-full pr-2">
                                {orders.map((order, index) => (
                                    <div
                                        onClick={() => onSelectOrder(order)}
                                        className={`relative flex py-5 border-y transition-all cursor-pointer ${
                                            selectedOrder?.orderNumber === order?.orderNumber
                                                ? "pl-2 border-l-[6px] border-l-primary rounded-lg"
                                                : "hover:pl-2 border-l-[6px] border-transparent hover:border-l-shade hover:rounded-lg"
                                        }`}
                                        key={index}
                                    >
                                        <div className="w-1/2">
                                            <h1 className="font-semibold truncate">
                                                {order.businessName.replace(/^FoodB_/, "")}
                                            </h1>
                                            <p className="text-sm text-primary underline">#{order.orderNumber}</p>
                                            <p className="text-sm">£ {order.totalPrice}</p>
                                            <p className="text-xs text-shade-dark">{`Paid by ${order.paymentMethod}`}</p>
                                        </div>
                                        <div className="w-1/2 flex flex-col items-center gap-2">
                                            <div className="w-2/3 sm:w-full flex gap-1 flex-col items-center">
                                                <p className="text-sm text-primary">
                                                    {order.status === "inprogressunpaid" ? "Preparing" : order.status}
                                                </p>
                                                <StatusLine small={true} status={3} />
                                            </div>
                                            <div className="text-right">
                                                <p className="capitalize text-sm">Type : {order.orderType}</p>
                                                <p className="text-xs text-shade-dark">Today, at 3:30 PM</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="flex justify-center items-center cursor-pointer w-fit mx-auto p-2 font-semibold text-shade-dark text-sm">
                                <span className="pr-1">{orders.length} orders made in </span>
                                <span className="flex justify-center items-center text-primary">
                                    {/* <ChevronDownIcon className="h-6 w-6 pt-1" /> */}
                                    <span> last 30 Days</span>
                                </span>
                            </div>
                        </>
                    ) : isLoading ? (
                        <LoadingSkeleton2 />
                    ) : (
                        <div className="border-t w-full flex justify-center items-center cursor-pointer mx-auto p-2 font-semibold text-shade-dark text-sm">
                            <p className="py-2">No orders yet</p>
                        </div>
                    )}
                </section>
                <section className="w-full md:w-2/3 md:ml-5 ">
                    {!isLoadingDetails ? (
                        selectedOrder ? (
                            <>
                                <div className="bg-white p-2 rounded-lg">
                                    <div className="m-2">
                                        <img className="my-2 w-12 h-12" src={`../../${icon}`} alt="Bunchiz" />
                                        <h1 className="text-2xl font-bold">
                                            {selectedOrder.businessName.replace(/^FoodB_/, "")}
                                        </h1>
                                        <h2 className="text-xl">Order #{selectedOrder.orderNumber}</h2>
                                    </div>
                                    <div className="m-2">
                                        <div className="w-full flex text-center rounded overflow-hidden">
                                            <p className="p-4 bg-shade-dark text-shade-light capitalize">
                                                {selectedOrder.orderType}
                                            </p>
                                            <p className="flex-1 p-4 bg-shade-light text-shade-dark">Table 1</p>
                                        </div>
                                    </div>
                                    <StatusLine status={3} />
                                    <div className="border-y-[1.5px] mx-2">
                                        {selectedOrder.orderItems.map((item, index) => (
                                            <div className="flex justify-between py-3" key={index}>
                                                <div className="flex">
                                                    <div className="px-1 min-w-[2rem] h-8 mr-2 flex justify-center items-center rounded-md bg-shade-light">
                                                        <p className="px-1 select-none">{item.quantity}</p>
                                                    </div>
                                                    <div className="flex flex-col">
                                                        <h2 className="text-sm font-light underline">{item.name}</h2>
                                                        {item.meal ? (
                                                            <>
                                                                <p className="text-xs text-gray-500 font-light">
                                                                    Make it A Meal
                                                                </p>
                                                                <p className="text-xs text-gray-500 font-light">
                                                                    {item.meal}
                                                                </p>
                                                            </>
                                                        ) : (
                                                            <p className="text-xs text-gray-500 font-light">Regular</p>
                                                        )}
                                                    </div>
                                                </div>
                                                <div>
                                                    <p className="text-sm font-light whitespace-nowrap">
                                                        £ {(parseFloat(item.price) * item.quantity).toFixed(2)}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="p-2 text-sm font-light">
                                        <span className="text-gray-400 flex justify-between">
                                            <p>Subtotal</p>
                                            <p>£{parseFloat(selectedOrder.totalPrice).toFixed(2)}</p>
                                        </span>
                                        <span className="text-gray-400 flex justify-between">
                                            <p>Service charge</p>
                                            <p>£{(0).toFixed(2)}</p>
                                        </span>
                                        {/* <span className="text-gray-400 flex justify-between">
                                            <p>Tip</p>
                                            <p>£{parseFloat(tipNumber).toFixed(2)}</p>
                                        </span> */}
                                        <span className="flex justify-between">
                                            <p>Total</p>
                                            <p>£{parseFloat(selectedOrder.totalPrice).toFixed(2)}</p>
                                        </span>
                                    </div>
                                </div>
                                <div className="mt-6 bg-white p-2 rounded-lg">
                                    <h2 className="text-xl p-2">Recipt</h2>
                                    <div className="flex flex-col gap-2 mx-2 py-2 border-y-[1.5px] text-sm">
                                        <div className="flex justify-between text-shade-dark">
                                            <div className="flex flex-col gap-1">
                                                <p>
                                                    {selectedOrder.paymentMethod === "card"
                                                        ? "Debit / Credit Card"
                                                        : selectedOrder.paymentMethod}
                                                </p>
                                                <p>**** **** **** 1234</p>
                                            </div>
                                            <p>{parseFloat(selectedOrder.totalPrice).toFixed(2)}</p>
                                        </div>
                                        <div className="flex justify-between">
                                            <p>Paid Total</p>
                                            <p>{parseFloat(selectedOrder.totalPrice).toFixed(2)}</p>
                                        </div>
                                    </div>
                                    <div className="py-2">
                                        <div className="p-2">
                                            <div className="flex h-12 items-center rounded border-l-4 cursor-pointer w-full border-primary bg-shade-light ">
                                                <p className="pl-3 text-sm font-light">Email</p>
                                            </div>
                                        </div>
                                        <div className="flex">
                                            <Input
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                type="email"
                                                placeholder="Email Address"
                                            />
                                            <button className="transition-colors bg-secondary hover:bg-primary hover:text-secondary text-shade-light rounded h-12 text-sm px-6 ml-0 m-2">
                                                Send
                                            </button>
                                        </div>
                                        <div className="p-2">
                                            <div className="flex h-12 items-center rounded border-l-4 cursor-pointer w-full border-shade bg-shade-light ">
                                                <p className="pl-3 text-sm font-light">SMS</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="w-full flex justify-center items-center cursor-pointer mx-auto p-2 font-semibold text-shade-dark text-sm">
                                <p className="py-2">No details available at the moment</p>
                            </div>
                        )
                    ) : (
                        <LoadingSkeleton3 />
                    )}
                </section>
            </div>
        </main>
    );
};
